import React from 'react';
import PropTypes from 'prop-types';

import { IComponent } from '../../../typings/generic-component';
import { LiveOnSkyType, liveOnSkyArray } from '../../../typings/match';
import { makeClassNames, IClassNames } from '../../../utils/styles';
import Text from '../text/text';
import './live-on-sky-badge.scss';
import { Color } from '../../../typings/design-tokens';
import t from '../../../labels/labelling-utils';

export interface ILiveOnSkyBadge extends IComponent {
  liveOnSky: LiveOnSkyType;
}

const classNames = (propClassName?: string): IClassNames =>
  makeClassNames({
    LiveOnSkyBadge: ['live-on-sky-badge', propClassName],
  });

const colorMap: Record<LiveOnSkyType, Color> = {
  LIVE: 'blue',
  EXCLUSIVE: 'red-light',
};

const labelMap: Record<LiveOnSkyType, string> = {
  LIVE: t('live-on-sky-badge.live'),
  EXCLUSIVE: t('live-on-sky-badge.exclusive'),
};

const LiveOnSkyBadge: React.FC<ILiveOnSkyBadge> = ({ liveOnSky, className, ...textProps }) => {
  const cn = classNames(className);

  const color = colorMap[liveOnSky];
  const label = labelMap[liveOnSky];

  return (
    <Text className={cn.LiveOnSkyBadge} fontSize="12--14" color={color} {...textProps}>
      {label}
    </Text>
  );
};

if (process.env.NODE_ENV !== 'production') {
  LiveOnSkyBadge.propTypes = {
    liveOnSky: PropTypes.oneOf(liveOnSkyArray).isRequired,
  };
}

export default LiveOnSkyBadge;
